import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const AccountProductFullPage = lazy(() => import('../views/list/AccountProductFullPage'));

export function AccountProductFullPageLazy() {
	return (
		<PageSuspense>
			<AccountProductFullPage />
		</PageSuspense>
	);
}
